import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ChangesSubject, DataChangesObserver, TitleService} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {PagesService} from '../../pages-services/pages.service';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';


@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
    haveChanges = false;
    changesCount = 0;
    changesSubject: ChangesSubject;
    countries = [];

    mdOptions = {
        hideIcons: ['Code']
    };
    modalRef: BsModalRef;

    @ViewChild('confirmationTemplate')
    confirmationTemplateRef: TemplateRef<any>;

    selectedMarket = 'en';
    previousSelectedMarket = 'en';
    pages = [];

    constructor(
        private titleService: TitleService,
        private route: ActivatedRoute,
        private pagesService: PagesService,
        private toasterService: ToasterService,
        private translateService: TranslateService,
        private datachanges: DataChangesObserver,
        private modalService: BsModalService
    ) {
    }

    ngOnInit() {
        this.pagesService.getLocalizations().subscribe((data) => {
            this.countries = data;
            this.getPagesData();
        });
    }


    savePagesData() {
        const locale = this.getCurrentLocale();
        this.pagesService.savePages(locale, {pages: this.pages}).subscribe(async (pages) => {
            this.pages = this.createChangesObservation(pages);
            let successMessage = await this.translateService.get('webpanel.save.pages.success_message').toPromise();
            this.toasterService.pop('success', '', successMessage);
        });

    }

    getCurrentLocale() {
        return this.countries.find(c => c.language === this.selectedMarket).locales[0];
    }

    getPagesData() {
        const locale = this.getCurrentLocale();
        if (locale) {
            this.pagesService.getPages(locale).subscribe(pages => {
                this.pages = this.createChangesObservation(pages);
            });
        }
    }

    localeChanged() {
        if (this.changesSubject.changesCount > 0) {
            this.modalRef = this.modalService.show(this.confirmationTemplateRef, {class: 'modal-sm'});
        } else {
            this.confirm();
        }
    }

    private createChangesObservation(settings) {
        this.changesCount = 0;
        this.haveChanges = false;
        let subject = this.datachanges.observe(settings);
        this.changesSubject = subject;
        subject.onChanges.subscribe((event) => {
            this.changesCount = event.subject.changesCount;
            this.haveChanges = this.changesCount > 0;
        });
        return subject.getProxy();
    }

    cancelChanges() {
        if (this.changesSubject) {
            this.changesSubject.cancelChanges();
        }
    }

    confirm() {
        if (this.modalRef) {
            this.modalRef.hide();
        }
        this.previousSelectedMarket = this.selectedMarket;
        this.getPagesData();
    }

    decline() {
        this.modalRef.hide();
        this.selectedMarket = this.previousSelectedMarket;
    }
}







// WEBPACK FOOTER //
// ./src/app/pages/pages/pages.component.ts